import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

$(function() {
    const $moreLocationsSec = $('.js-more-locations'),
        $content = $moreLocationsSec.find('.the-content'),
        $scrollableWidth = $moreLocationsSec.find('.the-width-400vh-scrollable-div');
    var totalWidth = 0;

    $content.children().each(function () {
        totalWidth += $(this).outerWidth(true);
    });

    $scrollableWidth.css('width', totalWidth);
    $moreLocationsSec.css('height', totalWidth);

    gsap.registerPlugin(ScrollTrigger);
    let section = document.querySelector('.js-more-locations-list');

    if (section) {
        let sectionStart = section.getBoundingClientRect().top + window.pageYOffset;
        gsap.fromTo(section, {x: 0}, {
            scrollTrigger: {
                start: sectionStart,
                end: 'max',
                invalidateOnRefresh: true,
                scrub: .5,
            },
            x: () => window.innerWidth - section.offsetWidth - 20,
        });
    }
});